export const EMAIL_TEMPLATE_REQUEST = "EMAIL_TEMPLATE_REQUEST";
export const EMAIL_TEMPLATE_SUCCESS = "EMAIL_TEMPLATE_SUCCESS";
export const EMAIL_TEMPLATE_FAIL = "EMAIL_TEMPLATE_FAIL";
